import { render, staticRenderFns } from "./SelectedVolunteerList.vue?vue&type=template&id=08fa34f4&scoped=true"
import script from "./SelectedVolunteerList.vue?vue&type=script&lang=js"
export * from "./SelectedVolunteerList.vue?vue&type=script&lang=js"
import style0 from "./SelectedVolunteerList.vue?vue&type=style&index=0&id=08fa34f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa34f4",
  null
  
)

export default component.exports